export const variables = {
  DEBUG_MODE: <string>import.meta.env.VITE_DEBUG_MODE,
  APP_INSIGHTS_CONNECTION_STRING: <string>(
    import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING
  ),
};
